function updateSelect(select) {
  const { selectedIndex, options } = select;

  if (selectedIndex < 0) return;

  const { text } = options[selectedIndex];

  if (text) {
    let sibling = select.parentNode.firstElementChild;
    // Loop through each sibling and push to the array
    while (sibling) {
      if (
        sibling.nodeType === 1
        && sibling !== select
        && (sibling.classList.contains('selected-text') || sibling.classList.contains('selected-option'))
      ) {
        sibling.innerText = text;
      }

      sibling = sibling.nextElementSibling;
    }
  }
}

export default class Select {
  constructor({ el }) {
    const { parentElement } = el;

    if (parentElement && !parentElement.classList.contains('select-wrapper') && !el.classList.contains('product-variants') && !el.classList.contains('select-disable-wrapper')) {
      const wrapperEl = document.createElement('div');
      const selectedTextEl = document.createElement('span');

      wrapperEl.classList.add('select-wrapper');
      selectedTextEl.classList.add('selected-text');
      wrapperEl.appendChild(selectedTextEl);
      parentElement.insertBefore(wrapperEl, el);
      wrapperEl.appendChild(el);
    }

    updateSelect(el);

    el.addEventListener('change', event => updateSelect(event.target));
  }
}
